import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import XNumberInput from '../../../../packages/kiti/components/form/NumberInput'
import { useSessionPermission } from '@btime/react-session'
import Textarea from '../../../../components/form/Textarea'

const StockInfoSection = () => {
  const { t } = useTranslation('editStocks')
  const canRemoveGeneralStockPermission = useSessionPermission('removeGeneralStock')

  return (
    <>
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {t('sections.stockInfo')}
      </Title>
      <Line />
      <Separator weight={2} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="33%" wrapOn="sm">
          <FormItem
            label={t('fields.amount')}
            field="amount"
            Input={XNumberInput}
            disabled={!canRemoveGeneralStockPermission}
          />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.minAmount')} field="minAmount" Input={XNumberInput} />
        </Col>

        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.maxAmount')} field="maxAmount" Input={XNumberInput} />
        </Col>

        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.criticalAmount')} field="criticalAmount" Input={XNumberInput} />
        </Col>

        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.warningAmount')} field="warningAmount" Input={XNumberInput} />
        </Col>

        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.notificationEmails')} field="notificationEmails" Input={Textarea} rows={1} />
        </Col>
      </Grid>
    </>
  )
}

export default StockInfoSection
